<template>
	<div>
		<!-- 侧边栏 -->
		<div class="aside show_aside">
			<div class="asideImgBox">
				<img src="../assets/logo.png" alt="">
			</div>
			<el-menu class="asideMenu" background-color="#ffffff" text-color="#00557f" :default-openeds="defaultOpeneds" >
				<!-- 固定的 一级导航 -->
				<div v-for="item in fasten">
					<el-menu-item @click="$emit('menu3',{categ_name:item.categ_name,categ_id:'',article_id: item.tab_id},'#/'+item.url)"
					 :index="item.url" v-if="item.categ_id == 0">
						<img :src="item.icon" alt="" style="width: 20px;height: 20px;margin-right: 10px;">
						<span slot="title">{{item.categ_name}}</span>
					</el-menu-item>
					<!-- 二级导航 -->
					<el-submenu index="recycle" v-else>
						<template slot="title">
							<img :src="item.icon" alt="" style="width: 20px;height: 20px;margin-right: 10px;">
							<span slot="title">{{item.categ_name}}</span>
						</template>
						<div v-for="item1 in item.children">
							<el-menu-item @click="$emit('menu3',{categ_name:item1.categ_name,categ_id:'',article_id: item1.tab_id},'#/'+item1.url)" :index="item1.url">
								<span slot="title">{{item1.categ_name}}</span>
							</el-menu-item>
						</div>
					</el-submenu>
				</div>
				<!-- 知识库 -->
				<el-submenu index="zsk">
					<template slot="title">
						<img src="../assets/lefticon/icon5.png" alt="" style="width: 20px;height: 20px;margin-right: 10px;">
						<span slot="title">知识库</span>
					</template>
					<div v-for="(item,index) in categ_List" :key="index">
						<!-- 二级菜单折叠 -->
						<el-submenu :index="index+''" v-if="item.children.length > 0">
							<template slot="title">
								<span slot="title">{{item.categ_name}}</span>
							</template>
							<!-- 三级菜单 -->
							<el-menu-item style="min-width: auto;" v-for="(item2,index2) in item.children" :key="index2" @click="$emit('menu3',item2,'#/articleList/')">
								{{item2.categ_name}}
							</el-menu-item>
						</el-submenu>
						<!-- 二级菜单 -->
						<el-menu-item :index=" '/articleList/' + item.categ_id " v-else style="min-width: auto;" @click="c_clue()">
							<span slot="title" >{{item.categ_name}}</span>
						</el-menu-item>
					</div>
				</el-submenu>
		
			</el-menu>
		
		</div>
	</div>
</template>

<script>
	import api from "../public/api.js"
	export default {
		/**
		 * categ_List 知识库分类数据
		 */
		props:['categ_List'],
		data() {
			return {
				// 自动展开知识库
				defaultOpeneds: ['zsk'],
				// 固定导航
				fasten:[
					{
						categ_name:"类别管理",
						url:'ht_categ',
						categ_id: 0,
						icon: require('../assets/lefticon/icon1.png'),
						tab_id: 1
					},
					{
						categ_name:"员工管理",
						url:'user',
						categ_id: 0,
						icon: require('../assets/lefticon/icon2.png'),
						tab_id: 2
					},
					{
						categ_name:"软件管理",
						url:'soft',
						categ_id: 0,
						icon: require('../assets/lefticon/icon3.png'),
						tab_id: 3
					},
					{
						categ_name:"回收站",
						categ_id: 1,
						icon: require('../assets/lefticon/icon4.png'),
						tab_id: 4,
						children:[
							{
								categ_name:"分类回收站",
								url:'categRecycle',
								tab_id: 41
							},
							{
								categ_name:"文章回收站",
								url:'articleRecycle',
								tab_id: 42
							}
						]
					},
				]
			}
		},
		created() {
		},
		methods:{
			c_clue(){
				this.$message("请先添加分类子级")
			},
		}
	}
</script>

<style scoped lang="less">
	.aside {
		background-color: #ffffff;
		color: #333;
		height: 100vh;
		overflow: auto;
		width: 190px;
	
		.asideImgBox {
			height: 8vh;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #f3f3f3;
			position: sticky;
			top: 0;
			z-index: 200;
			background-color: #fff;
	
			img {
				width: 150px;
				height: 40px;
				margin: 0 20px;
			}
		}
	
		.asideMenu {
			font-weight: bold;
			border-right: none;
		}
	}
	
// 移动端
@media(max-width: 992px){
	.aside{
		// border: 1px solid #ff0000;
		position: absolute;
		width: 100% !important;
		top: 0;
		height: 100vh;
		overflow: auto;
		.asideImgBox{
			position: sticky;
			top: 0;
			z-index: 10;
			background-color: #fff;
			img {
				width: 120px !important;
				height: 30px !important;
			}
		}
	}
}
// pc端
@media(min-width: 993px){}
</style>